<template>
  <q-page class="">
    <div class="centered-container fill-height q-px-xl q-pt-xl">
      <div class="row q-mt-lg items-center justify-between q-mb-lg">
        <div class="col-shrink text-left">
          <span class="text-h5"> {{ $page.props.i18n.title }}</span>
        </div>
      </div>

      <div class="row q-col-gutter-md q-mt-md justify-start">
        <div
          v-for="user in $page.props.collaborators"
          :key="user.id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3 self-stretch"
        >
          <q-card class="text-center fit">
            <q-card-section class="q-pt-lg">
              <div class="column items-center q-pa-md q-pt-lg">
                <q-avatar size="56px">
                  <img
                    :src="user.avatar_url"
                    referrerpolicy="no-referrer"
                  >
                </q-avatar>
                <div class="text-subtitle1 q-mt-md q-mb-xs">
                  {{ user.name }}
                </div>
                <div class="text-caption text-grey-6">
                  {{ user.email }}
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>

        <div class="col-12">
          <q-banner
            class="bg-pastel-blue q-px-md q-mt-lg"
            dense
            style="max-width: fit-content"
          >
            <template v-slot:avatar>
              <q-icon
                name="las la-info-circle"
                class="message-box-text"
                size="sm"
              />
            </template>
            <div
              class="text-caption message-box-text"
              style="font-weight: 400"
              v-html="$page.props.i18n.contact_support_to_manage"
            />
          </q-banner>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import Layout from '@/layouts/wg_admin.vue';

export default {
  components: {
  },
  layout: Layout,
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
};
</script>
